import React, { useCallback, useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { DoorOpen, DoorOpenFill } from 'react-bootstrap-icons';
import "react-datepicker/dist/react-datepicker.css";
import { headers, url } from '../../utils/const';
import './ventas.css';
import Tickets from '../tickets/tickets';
import { ToPrinter } from '../../utils/print';

function Venta() {
  let dataPrint={};
  const [ventas, setVentas] = useState({
    betted: 0,
    winned: 0,
    paid: 0,
    balance: 0,
    deposito: 0,
    retiro: 0,
    balancePlayer:0,
    point: '',
    tickets: [{
      num: 0,
      betted: 0,
      date: '',
      total:0,
      delete: false,
      winner: {
        jackpot: { value: 0 },
        state: false,
        factor: 1,
        amountWinner: 0,
        amountToPay: 0,
        paid: false,
      }
    }]
  })
  const [formDate, setFormDate] = useState({ init: new Date(), end: new Date() })
useEffect(() => GetVentas, []);
  /**Funcion para buscar las apuesta en el invtervalo  */
  const GetVentas = () => {
    fetch(`${url}/run/venta`, {
      method: "post",
      headers: headers,
      body: JSON.stringify(formDate),
    })
      .then((res) => res.json())
      .then((data) => {
        setVentas(data);
      });
  };
  /**Imprimir Reporte de Venta */
  const ToPrint = () => {
    const balance = ventas;
    balance.type = "cuadre"
    balance.logo ="hipico";
    balance.date = formDate.init.toLocaleDateString('es-ES') === formDate.end.toLocaleDateString('es-ES') ?
                `Fecha: ${formDate.init.toLocaleDateString('es-ES')}  Hora:${formDate.init.getHours()+':'+formDate.init.getMinutes()+':'+formDate.init.getSeconds()}` : `${formDate.init.toLocaleDateString('es-ES')} al ${formDate.end.toLocaleDateString('es-ES')}`
              
        console.log(balance)
    ToPrinter(balance)
  }
  return (
    <div>
      <div className='p-3 m3'>
      </div>
      <header className='noPrint p-3 m-3'>
        <nav>
          <div className="nvegador">
            <Link className='vol venta' to="/bet">VENTA</Link>
            <Link to="/line" className='vol lin'>LINEA</Link>
            <Link className='vol res' to='/line-pale'>LINEA PALE</Link>
            <Link className='vol volvent' to='/venta'>VOLUMEN DE VENTAS</Link>
            <Link className='vol res' to='/player'>JUGADORES</Link>
            <button className="boton_menu bg-danger" onClick={() => localStorage.clear()}><DoorOpenFill /></button>
          </div>
        </nav>
      </header>

      <div className=' card p-3 m-3 col-10 row noPrint'>

        <div className='col-12 text-center card-header'><h1>Reporte de Venta</h1></div>
        <div className=' col-12'>
          <hr />
          <div className='card-body row col-12 bg'>
            <div className='col-4'>
              <DatePicker className='form-control' selected={formDate.init} onSelect={(date) => setFormDate((value) => {
                return {
                  ...value, init: date
                }
              })} />
            </div>
            <div className='col-4'>
              <DatePicker className='form-control' selected={formDate.end} onSelect={(date) => setFormDate((value) => {
                return {
                  ...value, end: date
                }
              })} />
            </div>
            <div className='col-4 pb-3 mb-3'>
              <input className='btn btn-danger form-control' type="button" value='Buscar'
                onClick={GetVentas}
              />
            </div>
            <div className="col-12 row p-0 m-0">
              {typeof ventas == "object" ? (
                <div className="col-12 row pt-1 mt-1">
                  <div className="col-3 fs-5">
                    Monto Apostado: <strong>RD:$ {ventas? parseInt(ventas?.betted|0)?.toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Monto Ganado: <strong>RD:$ {ventas? parseInt(ventas.winned|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Monto Pagado: <strong>RD:$ {ventas? parseInt(ventas.paid|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Balance: <strong>RD:$ {ventas? parseInt(ventas.balance|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Recargas: <strong>RD:$ {ventas? parseInt(ventas.deposito|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Retiros: <strong>RD:$ {ventas? parseInt(ventas.retiro|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Balance: <strong>RD:$ {ventas? parseInt(ventas.balancePlayer|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                  <div className="col-3 fs-5 bg-warning">
                    Total en Caja: <strong className="fs-5">RD:$ {ventas?parseInt(ventas.total|0).toLocaleString("en-EN"):'0'}</strong>
                  </div>
                </div>
              ) : (
                <div>{ventas}</div>
              )}
              <div className="col-12 fs-5 row">
                <div className="col-4 p-3 m-3">
                  <input type="button" value="Print" onClick={async()=>ToPrint()} className="btn btn-primary form-control" />
                </div>
                <div className="col-6">{ventas && ventas.tickets?.length > 1 && <Tickets tickets={ventas.tickets} />}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Venta